export default {
    breadcrumbs: {
        referrals: 'Temporary Referrals',
        received: 'Received',
    },
    temporary_referral_message: 'This referral is temporary until the provider accepts it.',
    temporary_referral_message_expires: 'This referral is valid for 72 hours.',
}
